import { Component, Input } from '@angular/core';

@Component({
    selector: 'ssf-warning',
    template: require('./warning.component.html'),
    styles: [require('./warning.component.scss')]
})
export class WarningComponent {
    @Input() text: string;
    @Input() title: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/warning/warning.component.ts